// static UI
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text/Text'
import BigNumber from 'bignumber.js'
import { CashbackBonusType, UserBonus } from 'config/types/bonus/userBonus'
import { RowBetween } from 'layout/Components/Row'
import React, { useMemo } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { getFullDisplayBalance } from 'utils/formatBalance'
import BonusInvalid from 'views/BonusCenter/components/BonusInvalid'
import UpcomingBonus from 'views/BonusCenter/components/UpcomingBonus'
import BonusAction from '../../BonusAction'
import BonusItemCountdown from '../../BonusItemCountdown'

interface BonusItemProps {
  bonus: CashbackBonusType
}

const CashbackBonusContent: React.FC<BonusItemProps> = ({ bonus }) => {
  const parsedUserBonus = useMemo(() => bonus as UserBonus, [bonus])

  return (
    <Flex flexDirection="column" justifyContent="space-between" height="100%" width="100%">
      <RowBetween width="100%">
        <Text color="textSubtle" fontSize="12px" fontWeight="400" letterSpacing="-0.24px" width="120px">
          <Trans>Current profit</Trans>
        </Text>

        <Flex alignItems="center" mt="4px">
          <Text
            fontWeight="700"
            fontSize="14px"
            ml="4px"
            color={
              new BigNumber(bonus.cashbackProfitAmountInUsd).gt(0)
                ? 'success'
                : new BigNumber(bonus.cashbackProfitAmountInUsd).lt(0)
                ? 'error'
                : 'textTertiary'
            }
          >
            ${getFullDisplayBalance(bonus.cashbackProfitAmountInUsd, 0, 2)}
          </Text>
        </Flex>
      </RowBetween>

      <RowBetween mt="4px" alignItems="center">
        <Text color="textSubtle" fontSize="12px" fontWeight="400" letterSpacing="-0.24px" width="120px">
          <Trans>Est. Cashback</Trans>
        </Text>

        <Flex alignItems="center">
          <Text fontWeight="700" fontSize="14px" ml="4px">
            ${getFullDisplayBalance(bonus.cashbackReturnAmountInUsd, 0, 6)}
          </Text>
        </Flex>
      </RowBetween>

      <Flex width="100%" mt="20px">
        {bonus.condition.isExpired ? (
          <StyledBonusInvalid bonus={parsedUserBonus} />
        ) : (
          <>
            <BonusItemCountdown expiryDate={bonus.condition.expiryDate} onExpired={() => {}} />
            <Box width="8px" />
            <BonusAction bonus={parsedUserBonus} />
          </>
        )}
      </Flex>

      {parsedUserBonus.bonusUpcoming?.length > 0 && <UpcomingBonus mt="20px" bonus={parsedUserBonus} />}
    </Flex>
  )
}

const StyledBonusInvalid = styled(BonusInvalid)`
  height: 40px;
  border-radius: 8px;
  white-space: nowrap;
  box-sizing: border-box;
  padding: 0px !important;
  flex: 1 1;
  font-size: 14px;
  font-weight: bold;
`

export default CashbackBonusContent
